import React, {Component} from 'react';
import FieldWrapper from './Wrapper';

/*
* Component for rendering validated input field
* */
const ValidatedWrappedInputField = ({ input, label, placeholder, type, className, readOnly, min, meta: { touched, error } }) => {
    placeholder = placeholder || label;
    error = (touched) ? error : undefined;
    return <FieldWrapper
        label={label}
        error={error}
    >
        <input {...input} type={type} className={className} readOnly={readOnly} placeholder={placeholder} min={min}/>
    </FieldWrapper>
};

export default ValidatedWrappedInputField;


// WEBPACK FOOTER //
// ./web/src/components/common/form/ValidatedWrappedInputField.jsx